export const requiresInviteCode = (authState: any): boolean =>
  Boolean(authState?.inviteCodeRequired ?? authState?.invite_code_required);

export const guestLoginPath = (authState: any): '/auth/invite-code-login' | '/auth/guest-login' =>
  requiresInviteCode(authState) ? '/auth/invite-code-login' : '/auth/guest-login';
